import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { MainModal, Toggle, FeatureList } from '..';
import { ButtonGray, Center, LinkGray, Title } from '../styled';
import { formatDate } from '../../helpers/util';
import { getProductFeatures, GroupTypesB2C, Period } from '../../helpers/product';
import { modalActions } from '../../store/ducks/modal';
import { appActions } from '../../store/ducks/app';

const mapStateToProps = (state: any) => ({
  downgradeSubscriptionModal: state.modalData.downgradeSubscriptionModal,
  prescription: state.appData.prescription,
  subscription: state.appData.subscription,
  selectedPeriod: state.appData.general.selectedPeriod,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  toggleDowngradeSubscriptionModal: (isOpen: boolean) => void;
  switchPeriod: () => void;
  downgradeSubscription: () => void;
}
type Props = StateProps & DispatchProps;

class DowngradeModal extends React.Component<Props> {
  handleClose = (_event: any) => {
    this.props.toggleDowngradeSubscriptionModal(false);
  }

  render() {
    const { prescription, subscription, selectedPeriod } = this.props;
    return (
      <MainModal contentLabel="Downgrade Modal"
        isOpen={this.props.downgradeSubscriptionModal} close={this.handleClose} >
        <Title>
          <FormattedMessage id="downgrade_title" />
        </Title>
        <br />
        <span>
          <FormattedMessage id="downgrade_description"
            values={{ br: <br />, $1: formatDate(Number(subscription?.nextPaymentTimestamp) || prescription.end) }} />
        </span>
        <br />
        <FeatureList features={getProductFeatures(GroupTypesB2C.ESSENTIAL).filter(feature => !feature.checked)} />
        <br />
        {
          subscription?.status === 'active' && subscription?.billingPeriod === Period.MONTHLY &&
          <Toggle contentLabel="prefer_yearly_billing" handleChange={this.props.switchPeriod} checked={selectedPeriod !== Period.MONTHLY} />
        }
        <Center>
          <ButtonGray onClick={this.props.downgradeSubscription}>
            <FormattedMessage id="yes_downgrade" />
          </ButtonGray>
        </Center>
        <br />
        <Center>
          <LinkGray onClick={this.handleClose}><FormattedMessage id="no_keep_using_premium" /></LinkGray>
        </Center>
      </MainModal>
    );
  }
}

export default connect<StateProps, DispatchProps>(mapStateToProps, { ...appActions, ...modalActions })(DowngradeModal);
